module.exports = __webpack_public_path__ + "img/雷阵雨.522103db.png";